import React from "react";
import { ChevronLeftIcon } from "../../../../helper/HwIconExcursion";

const CheckIco = (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ClockIco = (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.9" />
    <path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const CrossIco = (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const BookingConfirmationAlert = ({ id, status, onBack }) => {
  if (!id) {
    return null;
  }
  const statuses = {
    cancel: "Your booking has been cancelled.",
    pending: "Your booking is currently pending confirmation. Please check your booking details later for update.",
    confirm: "Thank you! Your tickets are booked and on their way to your email.",
  };
  const displayStatus =
    status === "cancel" ? "Booking Cancelled" : status === "pending" ? "Booking Pending" : "Booking Confirmed";
  const tone = status === "cancel" ? "is-cancel" : status === "pending" ? "is-pending" : "is-confirm";
  const icon = status === "cancel" ? CrossIco : status === "pending" ? ClockIco : CheckIco;
  return (
    <div className={`hw-cfhero is-confirm`}>
      <div className="hw-exchk--heroInner">
        {onBack ? (
          <button type="button" className="hw-exchk--back hw-cfhero--back" onClick={onBack}>
            <ChevronLeftIcon /> Back to search
          </button>
        ) : null}
        <div className="hw-cfhero--bar">
          <div className="hw-cfhero--left">
            <span className="hw-cfhero--badge">{icon}</span>
            <div>
              <h1 className="hw-cfhero--title">{displayStatus}</h1>
              <p className="hw-cfhero--sub">{statuses[status]}</p>
            </div>
          </div>
          <div className="hw-cfhero--id">
            <span className="hw-cfhero--idVal">Booking ID : {id}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
